export default __webpack_public_path__ + "static/media/background.d317797b.png";